<template>
  <div class="counter">
    <Customdown deadline="October 14, 2020" stunden="12" ></Customdown>
  </div>
</template>

<script>
import Customdown from './CustomCounter.vue'
export default {
  name: "Counter",
  data() {
    return {};
  },
  methods: {
  },
  components: {
    Customdown
  }
};
</script>

<style >
.vuejs-countdown li > p {
  color: #dd2207;

  
}
li > .text {
  color: white !important;
}
.vuejs-countdown li:after {
  color: #dd2207;
  top: 25px !important;
}

.digit {
  font-size: 90px !important;
}
.text {
  font-size: 25px !important;
}
</style>